import Signupsuccess from '../../views/Signupsuccess';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickLoginHandler: value => {
      //console.log(value);
      dispatch(push(`/${locale}/login`));
    }
  };
};

const SignupsuccessComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Signupsuccess);

export default SignupsuccessComponent;



// WEBPACK FOOTER //
// ./src/components/container/Signupsuccess/index.js